import * as Types from 'src/actions/project/index/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import IndexResponse from 'src/value-objects/IndexResponse';

export interface IndexProjectsAttempt extends Action {
  type: Types.INDEX_PROJECTS_ATTEMPT;
}

export interface IndexProjectsSuccess extends Action {
  type: Types.INDEX_PROJECTS_SUCCESS;
  payload: {projects: Project[], key: string};
}

export interface IndexProjectsFailure extends Action {
  type: Types.INDEX_PROJECTS_FAILURE;
}

export type IndexProjectsAction = IndexProjectsAttempt | IndexProjectsSuccess | IndexProjectsFailure;

export interface IndexProjectsThunk extends ThunkAction<Promise<IndexProjectsAction>, RootState, string> {
}

export const indexProjectsAttempt: ActionCreator<IndexProjectsAttempt> = () => (
  {
    type: Types.INDEX_PROJECTS_ATTEMPT
  }
);

export const indexProjectsSuccess: ActionCreator<IndexProjectsSuccess> = (
  projects: {projects: Project[], key: string}) => (
  {
    type: Types.INDEX_PROJECTS_SUCCESS,
    payload: projects
  }
);

export const indexProjectsFailure: ActionCreator<IndexProjectsFailure> = () => (
  {
    type: Types.INDEX_PROJECTS_FAILURE
  }
);

export const indexProjects: ActionCreator<IndexProjectsThunk> =
  (key: string, status?: string, limit?: number, founderId?: number): IndexProjectsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<IndexProjectsAction> => {
      dispatch(indexProjectsAttempt());

      return ApiClient.project.index({status: status, limit: limit, founderId: founderId})
        .then((response: AxiosResponse<IndexResponse<Project>>): IndexProjectsSuccess => {
          return dispatch(indexProjectsSuccess({projects: response.data.content, key: key}));
        }).catch((): IndexProjectsFailure => {
          return dispatch(indexProjectsFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/index/IndexProjects.actions.tsx